module.exports = __webpack_public_path__ + "img/tab4.8951d574.png";